app.controller("StudentStateChangeController", ["$scope", "StaticData", "Students", "fileReader", "student", "toastr", "$http", "$uibModalInstance", "usSpinnerService",
    function ($scope,StaticData, Students, fileReader, student, toastr, $http, $uibModalInstance, usSpinnerService) {
        $scope.student = student;
        $scope.isDisabled = true;
        $scope.debt = false;
        $scope.note = "";
        $scope.currentState = student.state;

        $scope.$watch('chosenState', function (val) {
            if($scope.chosenState == $scope.currentState) $scope.isDisabled = true;
            else $scope.isDisabled = false;
        }, true);

        Students.stateList(student._id).then(function (data) {
            $scope.requestData = data[0];
            $scope.chosenState = $scope.currentState;
        });

        StaticData.getItemsByKey("states").then(function (states) {
            $scope.states = states;
            $scope.statesMap = _.keyBy($scope.states, '_id');
        });

        $scope.uploadFile = function (files) {
            $scope.document = files[0];
            $scope.documentName = $scope.document.name;
            fileReader.readAsDataUrl($scope.document, $scope).then(function (src) {
                $scope.documentSrc = src;
            })
        };

        $scope.changeState = function () {
            $scope.isDisabled = true;
            usSpinnerService.spin("root");
            var fd = new FormData();
            fd.append('document ', $scope.document );
            fd.append('state', $scope.chosenState);
            fd.append('note', $scope.note);
            fd.append('student', $scope.student._id);
            fd.append('debt', $scope.debt);

            $http.post('/student/state/change', fd, {
                headers: {'Content-Type': undefined}
            }).then(function (response) {
                var newState = $scope.statesMap[response.data.state].name;
                var curState = $scope.statesMap[$scope.currentState].name;
                toastr.success('', 'სტატუსი "' + curState + '" შეცვლილია "' + newState + 'თ"');
                $uibModalInstance.close();
            })
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
